import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommodityFilterService } from '../../shared/filter/commodity-filter.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { Observable } from 'rxjs';
import { FilterAssist } from '../../../models/filter-assist';
import { debounceTime, filter, map, mergeMap, switchMap } from 'rxjs/operators';
import { CommodityQuery } from '../../../models/commodity-query';
import { selectCommodityTableQuery } from '../../../store/commodity-table/commodity-table.state';
import { commodityTableAddAssist, commodityTableRemoveAssist } from '../../../store/commodity-table/commodity-table.actions';
import { AsyncPipe } from '@angular/common';
import { IconComponent } from '../../shared/icon/icon.component';
import { MatAutocomplete, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { MatChipGrid, MatChipInput, MatChipRemove, MatChipRow } from '@angular/material/chips';
import { MatFormField, MatInput } from '@angular/material/input';

@Component({
    selector: 'app-commodities-table-filter',
    imports: [
    AsyncPipe,
    IconComponent,
    MatAutocomplete,
    MatAutocompleteTrigger,
    MatChipGrid,
    MatChipInput,
    MatChipRemove,
    MatChipRow,
    MatFormField,
    MatInput,
    MatOption,
    ReactiveFormsModule,
    MatFormField
],
    templateUrl: './commodities-table-filter.component.html',
    styleUrl: './commodities-table-filter.component.scss'
})
export class CommoditiesTableFilterComponent {

    @ViewChild('termsInput') termsInput: ElementRef<HTMLInputElement>;

    public searchForm = new FormGroup({
        terms: new FormControl('')
    });

    constructor(private commodityFilterService: CommodityFilterService, private store: Store<AppState>) {}

    query$: Observable<CommodityQuery> = this.store.select(selectCommodityTableQuery);
    activeAssists$: Observable<FilterAssist[]> = this.query$.pipe(
        switchMap((query) => this.commodityFilterService.activeAssists(query))
    );
    offeredAssists$: Observable<FilterAssist[]> = this.searchForm.valueChanges.pipe(
        debounceTime(200),
        map(form => form.terms),
        filter(terms => typeof terms === 'string'),
        mergeMap(terms => this.commodityFilterService.autocompleteTerms(terms))
    );

    onAssistSelection(assist: FilterAssist): void {
        this.store.dispatch(commodityTableAddAssist({ id: assist.id, parameter: assist.parameter }));
        this.termsInput.nativeElement.value = '';
        this.searchForm.get('terms').setValue('');
    }

    onRemoveAssist(id: string): void {
        this.store.dispatch(commodityTableRemoveAssist({ id }));
    }

}
